/*
  ============================================================
  PHOTOGRAPHY PREMIUM
  Feature switches
  ============================================================

  Premium-templaten ominaisuuksia voidaan ottaa käyttöön
  asiakaskohtaisesti ilman ydinkomponenttien muuttamista.
*/

export const featureConfig = {
  /*
    Navigaatio
  */
  languageSwitcher: true,
  themeSwitcher: true,
  mobileMenu: true,

  /*
    Hero
  */
  heroVideo: true,
  heroScrollCue: true,

  /*
    Portfolio
  */
  portfolioLightbox: true,

  /*
    Motion
  */
  pageTransitions: true,
  scrollReveal: true,

  /*
    Sisältö
  */
  testimonials: true,
  contactForm: true,

  /*
    Analytics / privacy
  */
  analytics: true,
  cookieConsent: true,
};

export default featureConfig;
